import React, { HTMLAttributes, ReactNode } from 'react'

import { cn } from '@frame/lib/utils/cn'
import { PrimitiveDataAttribute } from '@frame/types'

type Props = {
  as?: 'h4' | 'div'
  children: ReactNode
  className?: HTMLAttributes<HTMLHeadingElement>['className']
}

export function H4({ children, className, as: Component = 'h4' }: Props) {
  return (
    <Component
      data-cy={PrimitiveDataAttribute.TW_PRIMITIVE_H4}
      className={cn('text-base font-semibold text-moss-950', className)}
    >
      {children}
    </Component>
  )
}
